<template>
    <div
        :class="{'dashed-border': isDashed}"
        class="mx-[1px] md:mx-0"
    >
        <table
            class="w-full table-base rounded"
            :class="{'disabled':disabled, 'cursorPointer':cursorPointer, 'ring-1 ring-gray-200':isBorder &&!isDashed}"
        >
            <!-- 'bg-green-100':isDashed&&!disabled -->
            <thead :class="{'gradient-primary':!isDashed&&!disabled,}">
                <slot name="thead" />
            </thead>
            <tbody class="divide-y divide-dashed">
                <slot name="tbody" />
            </tbody>
        </table>
    </div>
</template>

<script>
import { EUDC } from '@/utils/EUDC';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        isBorder: {
            type: Boolean,
            default: false
        },
        cursorPointer: {
            type: Boolean,
            default: true
        },
        isDashed: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        EUDC();
    }
};
</script>
<style lang="scss" scoped>
:deep(.table-base) {
    thead tr th,
    thead tr td {
        @apply px-2 xl:px-4 py-2 text-base text-left font-normal;
        &:first-child {
            @apply rounded-tl;
        }
        &:last-child {
            @apply rounded-tr;
        }
    }
    tbody tr {
        &:last-child {
            td:first-child {
                @apply rounded-bl;
            }
            td:last-child {
                @apply rounded-br;
            }
        }
        td {
            @apply px-2 xl:px-4 py-3;
        }
    }
    &:not(.disabled) {
        // @apply gradient-primary;
        &.cursorPointer {
            tbody tr {
                @apply cursor-pointer lg:hover:bg-gray-50;
            }
        }
        // thead tr {
        //     @apply gradient-primary;
        // }
        // thead tr {
        //     @apply bg-green-100;
        // }

        tbody tr {
            @apply odd:bg-white even:bg-blue-200 lg:text-lg text-gray-700;

            &.disabled {
                @apply bg-gray-50 lg:text-lg text-gray-200 border-b border-dashed last:border-0 cursor-not-allowed;
            }
        }
    }
    &.disabled {
        thead {
            @apply bg-gray-200 text-white;
        }
        tbody tr {
            @apply bg-gray-50 lg:text-lg text-gray-200 border-b border-dashed last:border-0 cursor-not-allowed;
        }
    }
}

.dashed-border {
    border-collapse: collapse;
    @apply rounded -m-0.5;

    @apply border border-green-600 border-dashed rounded;
    :deep(.table-base) {
        tbody tr {
            @apply odd:bg-white even:bg-white;
        }
        thead th,
        thead td {
            @apply bg-green-100 border-b border-dashed border-green-600;
            &:first-child {
                @apply rounded-tl;
            }
            &:last-child {
                @apply rounded-tr;
            }
        }

        tbody tr {
            @apply odd:bg-white even:bg-white;
            &:last-child {
                td:first-child {
                    @apply rounded-tl;
                }
                td:last-child {
                    @apply rounded-tr;
                }
            }
        }
    }
}
</style>
